let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2R8gf")).then(() => parcelRequire('5CafV'));